import React, { useEffect } from 'react';
import QuizOptions from '@components/Features/Quiz/QuizOptions';
import { getQuizChartColor } from '@components/Presentation/main/PresentationBody/InteractiveInteractions/Quiz';

const AnimatedQuizOption = ({
  option,
  index,
  timeLeft,
  animationStartTime = 14,
  playOptionAppearSound,
  showResponses,
  currentColors,
  currentSettings,
  relativeMax,
  isShowAnswerVisible,
  totalOptionCount,
  fontSize,
  roundedCorner,
  optionNumContainer,
  parentContainer,
  hasImage = false,
  forceVisible = false
}) => {
  useEffect(() => {
    if (timeLeft === animationStartTime) {
      setTimeout(() => {
        playOptionAppearSound();
      }, index * 200);
    }
  }, [timeLeft]);

  const isVisible = forceVisible || timeLeft <= animationStartTime;

  return (
    <div
      className={`transition-all duration-700 ease-out ${isVisible
        ? 'translate-y-0 opacity-100'
        : 'translate-y-full opacity-0'
      }`}
      style={{
        transitionDelay: isVisible ? `${index * 200}ms` : '0ms'
      }}
    >
      <QuizOptions
        showResponses={showResponses}
        colors={currentColors}
        chartColor={getQuizChartColor(currentColors, index)}
        option={option}
        settings={currentSettings}
        index={index}
        relativeMax={relativeMax}
        showAnswer={isShowAnswerVisible}
        totalOptionCount={totalOptionCount}
        fontSize={fontSize}
        roundedCorner={roundedCorner}
        optionNumContainer={optionNumContainer}
        parentContainer={parentContainer}
        hasImage={hasImage}
      />
    </div>
  );
};

export default AnimatedQuizOption;
